var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 61,
    viewBox: "0 0 96 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.2929 0.792893C87.6834 0.402369 88.3166 0.402369 88.7071 0.792893L95.0711 7.15685C95.4616 7.54738 95.4616 8.18054 95.0711 8.57107C94.6805 8.96159 94.0474 8.96159 93.6569 8.57107L88 2.91421L82.3431 8.57107C81.9526 8.96159 81.3195 8.96159 80.9289 8.57107C80.5384 8.18054 80.5384 7.54738 80.9289 7.15685L87.2929 0.792893ZM1 60.1343C0.447716 60.1343 0 59.6866 0 59.1343C0 58.582 0.447716 58.1343 1 58.1343V60.1343ZM89 1.5V11.1343H87V1.5H89ZM40 60.1343H1V58.1343H40V60.1343ZM89 11.1343C89 22.4197 89.0021 30.9844 88.1124 37.602C87.2188 44.2485 85.4092 49.0805 81.6777 52.8119L80.2635 51.3977C83.5614 48.0998 85.2665 43.7602 86.1302 37.3356C86.9979 30.8821 87 22.4763 87 11.1343H89ZM40 58.1343C51.342 58.1343 59.7479 58.1322 66.2013 57.2645C72.6259 56.4007 76.9655 54.6957 80.2635 51.3977L81.6777 52.8119C77.9462 56.5434 73.1142 58.3531 66.4678 59.2467C59.8501 60.1364 51.2854 60.1343 40 60.1343V58.1343Z",
    fill: "url(#paint0_radial_68_3106)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_68_3106",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.1468 1.5) rotate(131.492) scale(95.5775 87.1406)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8FF01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#95FB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8FF01"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.2d3a31154ab5293600a15d4e7dc4cc43.svg";
export { ForwardRef as ReactComponent };